import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    smallFieldsWrap: {
      '& .MuiOutlinedInput-inputMultiline': {
        minHeight: 160,
      },
    },

    buttonsBase: {
      borderTop: `1px solid ${palette.borderGray}`,
      justifyContent: 'right',
    },
    buttonsAlign: {
      justifyContent: 'flex-end',
      display: 'flex',
      padding: '10px 0px 4px',
    },
    formContainer: {
      margin: 0,
    },
    slidersRootDiv: {
      paddingInline: '8px',
    },
    sliderItem: {
      padding: '4px 0',
    },
  });
